import { Button, PressEvent } from "react-aria-components";
import { styled } from "styled-components";
import { useHistoryReplayContext } from "./history-replay-context";
import { convertValueFromOldRangeToNewRange } from "../../chart/chart.utils";

export function HistoryTimeLineClickarea() {
  const {
    movePlayheadTo,
    isLoading,
    timelineDomainInSeconds,
    timeLineContainerSize,
  } = useHistoryReplayContext();

  const onPress = (e: PressEvent) => {
    const x = convertValueFromOldRangeToNewRange(
      e.x,
      [0, timeLineContainerSize.width],
      timelineDomainInSeconds,
    );
    movePlayheadTo(x);
  };
  return <ClickContainer onPress={onPress} isDisabled={isLoading} />;
}
const ClickContainer = styled(Button)`
  position: relative;
  width: 100%;
  height: 150%;
  bottom: 80px;
  cursor: ${(p) => (p.isDisabled ? "not-allowed" : "pointer")};
`;
